export const setClicked = (item, value) => ({
  type: "SET_CLICKED",
  payload: { item, value },
});
